import { bootstrapApplication } from '@angular/platform-browser';
import { AppComponent } from './app/app.component';
import { appConfig } from './app/app.config';

import { initializeApp } from 'firebase/app';
import { firebaseConfig } from './environments/firebase-config';
import { provideAnimations } from '@angular/platform-browser/animations';

// Initialize Firebase before bootstrapping Angular
initializeApp(firebaseConfig);

if ('serviceWorker' in navigator) {
  navigator.serviceWorker.register('firebase-messaging-sw.js')
    .then((registration) => {
      //console.log('Service Worker registered with scope:', registration.scope);
    }).catch((err) => {
      //console.error('Service Worker registration failed:', err);
    });
}

// Merge appConfig with animations provider in one config object
const bootstrapConfig = {
  ...appConfig,
  providers: [
    ...(appConfig.providers ?? []), // old providers if any
    provideAnimations()
  ]
};

bootstrapApplication(AppComponent, bootstrapConfig)
  .catch((err) => console.error(err));
